// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Unified Status Badge Styles */
.status-badge {
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  padding: 0.4rem 0.85rem !important;
  border-radius: 8px !important;
  font-size: 0.75rem !important;
  font-weight: 700 !important;
  text-transform: none !important;
  letter-spacing: 0 !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;
  transition: box-shadow 0.2s ease !important;
  position: relative !important;
  overflow: hidden !important;
  min-width: auto !important;
  max-width: 100% !important;
  border: 1px solid transparent !important;
  white-space: nowrap !important;
  line-height: 1 !important;
}

.status-badge-compact {
  padding: 0.3rem 0.7rem !important;
  font-size: 0.7rem !important;
  min-width: auto !important;
}

/* Крупный бейдж статуса в шапке карточки жалобы (детальная страница) */
.status-badge.status-badge--complaint-hero {
  padding: 0.55rem 1.15rem !important;
  font-size: 0.9375rem !important;
  border-radius: 11px !important;
  min-height: 2.25rem !important;
}

.status-badge::before {
  display: none;
}

.status-badge:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

/* Order Statuses */
.status-order-in-progress {
  background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%);
  color: #1e40af;
  border-color: #93c5fd;
}

.status-order-in-work {
  background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
  color: #92400e;
  border-color: #fcd34d;
}

.status-order-done {
  background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);
  color: #065f46;
  border-color: #6ee7b7;
}

.status-order-canceled {
  background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);
  color: #991b1b;
  border-color: #fca5a5;
}

.status-order-blocked {
  background: linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%);
  color: #6b7280;
  border-color: #9ca3af;
}

/* User Statuses */
.status-user-active {
  background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);
  color: #065f46;
  border-color: #6ee7b7;
}

.status-user-inactive {
  background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);
  color: #92400e;
  border-color: #fcd34d;
}

.status-user-blocked {
  background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);
  color: #991b1b;
  border-color: #fca5a5;
}

/* Complaint Statuses */
.status-complaint-pending {
  background: linear-gradient(135deg, #fff7ed 0%, #fed7aa 100%);
  color: #c2410c;
  border-color: #fdba74;
}

.status-complaint-in-review {
  background: linear-gradient(135deg, #eef2ff 0%, #c7d2fe 100%);
  color: #4f46e5;
  border-color: #a5b4fc;
}

.status-complaint-resolved {
  background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);
  color: #065f46;
  border-color: #6ee7b7;
}

.status-complaint-rejected {
  background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);
  color: #991b1b;
  border-color: #fca5a5;
}

/* Unknown Status */
.status-unknown {
  background: linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%);
  color: #374151;
  border-color: #d1d5db;
}

/* Responsive Design */
@media (max-width: 768px) {
  .status-badge {
    padding: 0.35rem 0.75rem !important;
    font-size: 0.7rem !important;
    min-width: auto !important;
  }

  .status-badge-compact {
    padding: 0.25rem 0.6rem !important;
    font-size: 0.65rem !important;
    min-width: auto !important;
  }
}

@media (max-width: 480px) {
  .status-badge {
    padding: 0.3rem 0.65rem !important;
    font-size: 0.65rem !important;
    min-width: auto !important;
    letter-spacing: 0.03em !important;
  }

  .status-badge-compact {
    padding: 0.2rem 0.5rem !important;
    font-size: 0.6rem !important;
    min-width: auto !important;
  }
}

/* Accessibility */
@media (prefers-reduced-motion: reduce) {
  .status-badge,
  .status-badge::before {
    transition: none;
  }

  .status-badge:hover {
    transform: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/css/status-badge.css"],"names":[],"mappings":"AAAA,gCAAgC;AAChC;EACE,+BAA+B;EAC/B,8BAA8B;EAC9B,kCAAkC;EAClC,kCAAkC;EAClC,6BAA6B;EAC7B,6BAA6B;EAC7B,2BAA2B;EAC3B,+BAA+B;EAC/B,4BAA4B;EAC5B,mDAAmD;EACnD,2CAA2C;EAC3C,6BAA6B;EAC7B,2BAA2B;EAC3B,0BAA0B;EAC1B,0BAA0B;EAC1B,wCAAwC;EACxC,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA,uEAAuE;AACvE;EACE,mCAAmC;EACnC,+BAA+B;EAC/B,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,0CAA0C;AAC5C;;AAEA,mBAAmB;AACnB;EACE,6DAA6D;EAC7D,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,qBAAqB;AACvB;;AAEA,kBAAkB;AAClB;EACE,6DAA6D;EAC7D,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,qBAAqB;AACvB;;AAEA,uBAAuB;AACvB;EACE,6DAA6D;EAC7D,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,6DAA6D;EAC7D,cAAc;EACd,qBAAqB;AACvB;;AAEA,mBAAmB;AACnB;EACE,6DAA6D;EAC7D,cAAc;EACd,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB;EACE;IACE,mCAAmC;IACnC,4BAA4B;IAC5B,0BAA0B;EAC5B;;EAEA;IACE,kCAAkC;IAClC,6BAA6B;IAC7B,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,kCAAkC;IAClC,6BAA6B;IAC7B,0BAA0B;IAC1B,iCAAiC;EACnC;;EAEA;IACE,iCAAiC;IACjC,4BAA4B;IAC5B,0BAA0B;EAC5B;AACF;;AAEA,kBAAkB;AAClB;EACE;;IAEE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* Unified Status Badge Styles */\n.status-badge {\n  display: inline-flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  padding: 0.4rem 0.85rem !important;\n  border-radius: 8px !important;\n  font-size: 0.75rem !important;\n  font-weight: 700 !important;\n  text-transform: none !important;\n  letter-spacing: 0 !important;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1) !important;\n  transition: box-shadow 0.2s ease !important;\n  position: relative !important;\n  overflow: hidden !important;\n  min-width: auto !important;\n  max-width: 100% !important;\n  border: 1px solid transparent !important;\n  white-space: nowrap !important;\n  line-height: 1 !important;\n}\n\n.status-badge-compact {\n  padding: 0.3rem 0.7rem !important;\n  font-size: 0.7rem !important;\n  min-width: auto !important;\n}\n\n/* Крупный бейдж статуса в шапке карточки жалобы (детальная страница) */\n.status-badge.status-badge--complaint-hero {\n  padding: 0.55rem 1.15rem !important;\n  font-size: 0.9375rem !important;\n  border-radius: 11px !important;\n  min-height: 2.25rem !important;\n}\n\n.status-badge::before {\n  display: none;\n}\n\n.status-badge:hover {\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n}\n\n/* Order Statuses */\n.status-order-in-progress {\n  background: linear-gradient(135deg, #dbeafe 0%, #bfdbfe 100%);\n  color: #1e40af;\n  border-color: #93c5fd;\n}\n\n.status-order-in-work {\n  background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);\n  color: #92400e;\n  border-color: #fcd34d;\n}\n\n.status-order-done {\n  background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);\n  color: #065f46;\n  border-color: #6ee7b7;\n}\n\n.status-order-canceled {\n  background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);\n  color: #991b1b;\n  border-color: #fca5a5;\n}\n\n.status-order-blocked {\n  background: linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%);\n  color: #6b7280;\n  border-color: #9ca3af;\n}\n\n/* User Statuses */\n.status-user-active {\n  background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);\n  color: #065f46;\n  border-color: #6ee7b7;\n}\n\n.status-user-inactive {\n  background: linear-gradient(135deg, #fef3c7 0%, #fde68a 100%);\n  color: #92400e;\n  border-color: #fcd34d;\n}\n\n.status-user-blocked {\n  background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);\n  color: #991b1b;\n  border-color: #fca5a5;\n}\n\n/* Complaint Statuses */\n.status-complaint-pending {\n  background: linear-gradient(135deg, #fff7ed 0%, #fed7aa 100%);\n  color: #c2410c;\n  border-color: #fdba74;\n}\n\n.status-complaint-in-review {\n  background: linear-gradient(135deg, #eef2ff 0%, #c7d2fe 100%);\n  color: #4f46e5;\n  border-color: #a5b4fc;\n}\n\n.status-complaint-resolved {\n  background: linear-gradient(135deg, #d1fae5 0%, #a7f3d0 100%);\n  color: #065f46;\n  border-color: #6ee7b7;\n}\n\n.status-complaint-rejected {\n  background: linear-gradient(135deg, #fee2e2 0%, #fecaca 100%);\n  color: #991b1b;\n  border-color: #fca5a5;\n}\n\n/* Unknown Status */\n.status-unknown {\n  background: linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%);\n  color: #374151;\n  border-color: #d1d5db;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .status-badge {\n    padding: 0.35rem 0.75rem !important;\n    font-size: 0.7rem !important;\n    min-width: auto !important;\n  }\n\n  .status-badge-compact {\n    padding: 0.25rem 0.6rem !important;\n    font-size: 0.65rem !important;\n    min-width: auto !important;\n  }\n}\n\n@media (max-width: 480px) {\n  .status-badge {\n    padding: 0.3rem 0.65rem !important;\n    font-size: 0.65rem !important;\n    min-width: auto !important;\n    letter-spacing: 0.03em !important;\n  }\n\n  .status-badge-compact {\n    padding: 0.2rem 0.5rem !important;\n    font-size: 0.6rem !important;\n    min-width: auto !important;\n  }\n}\n\n/* Accessibility */\n@media (prefers-reduced-motion: reduce) {\n  .status-badge,\n  .status-badge::before {\n    transition: none;\n  }\n\n  .status-badge:hover {\n    transform: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
